/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { PayoutReportAction, STORE_PAYOUT_REPORTS } from "../actions/actions";
import { PayoutReport } from "../../models/model";

export function payoutReports(
    state: PayoutReport[] = [],
    action: PayoutReportAction
): PayoutReport[] {
    switch (action.type) {
        case STORE_PAYOUT_REPORTS: {
            return action.payload;
        }
        default:
            return state;
    }
}
